export const GLOBAL_STATE = 'Letters'

export const LETTER_CREATE = 'LETTER_CREATE'
export const LETTER_DELETE = 'LETTER_DELETE'
export const LETTER_INCOMING_LIST = 'LETTER_INCOMING_LIST'
export const LETTER_OUTGOING_LIST = 'LETTER_OUTGOING_LIST'
export const LETTER_STATUS = 'LETTER_STATUS'
export const LETTER_PUBLIC_INFO = 'LETTER_PUBLIC_INFO'
